import { checkEmail, checkNotNull, checkNotNullLicense } from './Rules'

export default {
    firstname: [
        {
            required: true,
            message: Loc.g('Ce champ est requis'),
            trigger: 'blur'
        },
    ],
    lastname: [
        {
            required: true,
            message: Loc.g('Ce champ est requis'),
            trigger: 'blur'
        },
    ],
    email: [
        {
            required: true,
            message: Loc.g('Veuillez renseigner une adresse email valide'),
            trigger: 'blur'
        },
        { validator: checkEmail, trigger: 'blur' },
    ],
    team: [
        {
            required: true,
            message: Loc.g('Ce champ est requis'),
            trigger: 'blur'
        },
        { validator: checkNotNull, trigger: 'blur' }
    ],
    job: [
        {
            required: true,
            message: Loc.g('Ce champ est requis'),
            trigger: 'blur'
        },
        { validator: checkNotNull, trigger: 'blur' }
    ],
    profile: [
        {
            required: true,
            message: Loc.g('Ce champ est requis'),
            trigger: 'blur'
        },
        { validator: checkNotNull, trigger: 'blur' }
    ],
    licenses: [
        {
            required: true,
            message: Loc.g('Ce champ est requis'),
            trigger: 'blur'
        },
        { validator: checkNotNullLicense, trigger: 'blur' }
    ],
    timezone: [
        {
            required: true,
            message: Loc.g('Ce champ est requis'),
            trigger: 'blur'
        },
        { validator: checkNotNull, trigger: 'blur' }
    ],
    language: [
        {
            required: true,
            message: Loc.g('Ce champ est requis'),
            trigger: 'blur'
        },
        { validator: checkNotNull, trigger: 'blur' }
    ],
}
